import React, { Component, Fragment } from "react";
import * as R from "ramda";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import MasterCOAHeader from "./MasterCOAHeader";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import { initialDataDetail, tableColumns } from "../config/config";
import Api from "../../../../Services/Api";
import { ACTIVITY_TYPE, HttpStatus } from "../../../common/Constants";
import { mapToObjectDDL } from "../../../common/mapper";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import { getDataDetail, validateDataItem } from "../util";
import { fetchDataItem } from "../service";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import { contructQueryParam, fetchDataAsync } from "../../../../Services/Utils";

class MasterCOAModifying extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      warningModalVisible: false,
      warningModalMessage: "",
      errorListCabang: undefined,
      errorGracePeriod: undefined,
      errorStartDate: undefined,
      errorEndDate: undefined,
      tableColumn: [],
      dataTable: [],
      dataDetailSaved: [],
      selectedRow: null,
      dataSubgoup: [],
      dataKategori: [
        { label: "TRX_IN", value: "TRX_IN" },
        { label: "TRX_OUT", value: "TRX_OUT" },
      ],
      dataItem: [],
      pagination: {
          page: 1,
          limit: 5,
          totalData: 0,
      },
    };
  }

  componentDidMount = async () => {
    this.handleTriggerLoading();

    if (R.equals(this.props.activityType, ACTIVITY_TYPE.CREATE)) {
      const id = await this.fetchMasterCOAId();
      this.props.setValue("coaId", id);
    }

    if (R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE)) {
      await this.fetchDataDetail();
    }

    const listSubGroup = await this.fetchDataBizpar({
      paramFilters: { bizparCategory: "SUB_GROUP_COA" },
    });
    const listGroup = await this.fetchDataBizpar({
      paramFilters: { bizparCategory: "GROUP_COA" },
    });

    this.setState({
      tableColumn: tableColumns.detailPage(
        this.handleSaveRow,
        this.handleEditRow,
        this.handleCancelRow,
        this.handleDeleteRow,
        this.handleValueChange,
        this.handleToggleClick,
        this.handleCategoryChange,
        this.handleItemChange,
        listSubGroup,
        listGroup,
        this.state.dataKategori,
        this.state.dataItem,
        "Detail"
      ),
      dataSubgoup: listSubGroup,
      dataGroup: listGroup,
    });

    this.handleTriggerLoading();
  };

  componentDidUpdate = async (prevProps, prevState) => {
    if (prevState.dataTable !== this.state.dataTable) {
      this.props.setValue("listDetail", this.state.dataDetailSaved);
    }

    if (prevState.dataItem !== this.state.dataItem) {
      this.setState((prevState) => ({
        ...prevState,
        tableColumn: tableColumns.detailPage(
          this.handleSaveRow,
          this.handleEditRow,
          this.handleCancelRow,
          this.handleDeleteRow,
          this.handleValueChange,
          this.handleToggleClick,
          this.handleCategoryChange,
          this.handleItemChange,
          prevState.dataSubgoup,
          prevState.dataGroup,
          prevState.dataItem,
          prevState.dataKategori,
          "Detail"
        ),
      }));
    }
  };

  handleWarningModalVisibility = (message) => {
    this.setState((prevState) => ({
      ...prevState,
      warningModalVisible: !prevState.warningModalVisible,
      warningModalMessage: message,
    }));
  };

  handleSubmit = () => {
    const { dataTable } = this.state;
    const { controls, activityType } = this.props;

    let valid = true;
    if (!this.props.validate()) valid = false;
    if (!this.validateListCabang()) valid = false;
    if (!this.validateSavedDetail()) valid = false;

    if (!valid) return;

    
    const coaId =
      activityType === "CREATE" ? null : controls?.coaId?.value || null;

    
    const masterCoaDetailDTOS = dataTable.map((item) => ({
      id: item.id || null,
      coaId: coaId,
      coaDetailId: item.coaDetailId
        ? item.coaDetailId.split("-").pop() 
        : null,
      transactionType: item.transactionType || null,
      category: item.category?.value || null,
      subGroup: item.subGroup?.value || null,
      group: item.group?.value || null,
      status: item.status || null,
    }));

    
    const masterCoaCabangDTOS = (
      controls?.masterCoaCabangDTOS?.value || []
    ).map((item) => ({
      coaId: coaId,
      coaCabangId: item.coaCabangId || null, 
      kodeCabang: item.value || null,
    }));

    const reqBody = {
      coaId: coaId,
      coaName: controls?.coaName?.value || null,
      status: controls?.status?.value || null,
      masterCoaDetailDTOS,
      masterCoaCabangDTOS,
    };

    this.props.onSubmit(reqBody);
  };

  validateSavedDetail() {
    let data = this.state.dataTable;
    let anyNotSaved = data.some(item => !item.saved);
    if (anyNotSaved) {
      this.handleWarningModalVisibility("Ada data yang belum diisi atau data detail yang belum di save.");
    }
    return !anyNotSaved;
  }

  handleAddRow = async () => {
    const { controls } = this.props;
    const prefix = controls?.coaId?.value || "COA01";

    this.setState((prevState) => {
      const nextNumber = prevState.dataTable.length + 1;
      const sequence = String(nextNumber).padStart(3, "0");

      const newData = {
        coaDetailId: `${prefix}-TRX${sequence}`,
        ...initialDataDetail,
        status: "ACTIVE",
        isNew: true,
      };

      return {
        ...prevState,
        dataTable: [...prevState.dataTable, newData],
      };
    });
  };

  handleSaveRow = (index) => {
    let errors = validateDataItem(this.state.dataTable[index]);
    if (!R.isNil(errors) && !R.isEmpty(errors)) {
      this.handleWarningModalVisibility(" Ada field data yang perlu diisi atau tidak sesuai kriteria isian.");
      return;
    }

    this.setState((prevState) => {
      const newData = [...prevState.dataTable];
      newData[index] = {
        ...newData[index],
        isNew: false,
        saved: true,
      };

      return {
        ...prevState,
        dataTable: newData,
        dataDetailSaved: newData,
        selectedRow: !R.isNil(prevState.selectedRow)
          ? Object.values(prevState.selectedRow || []).filter(
              (item) => item.id !== newData[index].id
            )
          : null,
      };
    });
  };

  handleEditRow = (index) => {
    this.setState((prevState) => {
      const newData = [...prevState.dataTable];
      const currentRow = newData[index];

      if (currentRow.saved) {
        return {
          ...prevState,
          dataTable: newData.map((row, i) =>
            i === index ? { ...row, saved: false } : row
          ),
          selectedRow: {
            ...prevState.selectedRow,
            [index]: { ...currentRow },
          },
        };
      }

      const prevRow = prevState.selectedRow?.[index];
      if (prevRow) {
        newData[index] = { ...prevRow };
      }

      const updatedSelectedRow = { ...prevState.selectedRow };
      delete updatedSelectedRow[index];

      return {
        ...prevState,
        dataTable: newData,
        selectedRow: updatedSelectedRow,
      };
    });
  };

  handleCancelRow = (index) => {
    this.setState((prevState) => {
      let dataTable = [...prevState.dataTable];
      if (R.isNil(prevState.selectedRow) || R.isEmpty(prevState.selectedRow)) {
        dataTable = dataTable.filter((_, idx) => idx !== index);
      } else {
        dataTable[index] = Object.values(prevState.selectedRow).find(
          (item) => item.id === dataTable[index].id
        );
      }

      return {
        ...prevState,
        dataTable,
        selectedRow:
          !R.isNil(prevState.selectedRow) && !R.isEmpty(prevState.selectedRow)
            ? Object.values(prevState.selectedRow).filter(
                (item) => item.id !== dataTable[index].id
              )
            : null,
      };
    });
  };

  handleDeleteRow = (index) => {
    this.setState((prevState) => ({
      ...prevState,
      dataTable: prevState.dataTable.filter((_, idx) => idx !== index),
      dataDetailSaved: prevState.dataDetailSaved.filter(
        (_, idx) => idx !== index
      ),
    }));
  };

  handleValueChange = (index, name, value) => {
    this.setState((prevValue) => {
      const newState = [...prevValue.dataTable];
      newState[index] = {
        ...newState[index],
        [name]: value,
      };

      return {
        ...prevValue,
        dataTable: newState,
      };
    });
  };

  handleToggleClick = (rowIndex, newStatus) => {
    this.setState((prevState) => {
      const newData = [...prevState.dataTable];
      newData[rowIndex] = {
        ...newData[rowIndex],
        status: newStatus,
      };
      return { dataTable: newData };
    });
  };

  handleCategoryChange = async (index, name, value) => {
    this.setState((prevState) => {
      const newData = [...prevState.dataTable];
      newData[index] = {
        ...newData[index],
        [name]: value,
        name: null,
        kode: null,
        satuan: null,
      };

      return {
        ...prevState,
        dataTable: newData,
      };
    });

    this.handleTriggerLoading();
    await this.fetchDataItem(index, value.value);
    this.handleTriggerLoading();
  };

  handleItemChange = (index, name, value) => {
    this.setState((prevState) => {
      const newData = [...prevState.dataTable];
      newData[index] = {
        ...newData[index],
        [name]: value,
      };

      return {
        ...prevState,
        dataTable: newData,
      };
    });
  };

  validateListCabang = () => {
    const { masterCoaCabangDTOS } = this.props.controls;

    if (R.isNil(masterCoaCabangDTOS?.value) || masterCoaCabangDTOS?.value.length === 0) {
      this.setState({ errorListCabang: "Field belum diisi" });
      return false;
    }

    this.setState({ errorListCabang: null });
    return true;
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  fetchMasterCOAId = async () => {
    try {
      let res = await Api.create("NAGAMAS_MASTER_DATA").generateMasterCOAId();
      return res.ok ? res.data.data : null;
    } catch (error) {
      console.log("error: ", error);
    }
  };

  fetchDataDetail = async () => {
    let id = this.props.controls.coaId?.value;
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getMasterCOAById,
      menuName: "Master COA",
      setError: this.props.setError,
      args: contructQueryParam({ coaId: id }),
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const masterCoaCabangDTOS = res.data.data?.masterCoaCabangDTOS?.map(
        (item) => mapToObjectDDL(item.namaCabang, item.kodeCabang)
      );
      this.props.setValue("masterCoaCabangDTOS", masterCoaCabangDTOS);
      this.props.setValue("masterCoaDetailDTOS", res.data.data?.masterCoaDetailDTOS);

      const detailData = getDataDetail(res.data.data.masterCoaDetailDTOS);
      this.setState((prevValue) => ({
        dataTable: detailData,
        dataDetailSaved: detailData,
        pagination: {
            ...prevValue.pagination,
            totalData: res.data.data.length,
        }
      }));
    }
  };

  fetchDataBizpar = async (body) => {
    try {
      const res = await Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam(
        body
      );
      if (res.ok) {
        return res.data.data;
      }
    } catch (error) {
      console.log("errors: ", error);
    }
    return null;
  };

  fetchDataItem = async (index, categoryId) => {
    const res = await fetchDataItem("Detail", categoryId);
    this.setState((prevState) => ({
      ...prevState,
      dataItem: {
        ...prevState.dataItem,
        [index]: res,
      },
    }));
  };

  handleChangePage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: tableState.page + 1,
          }
      }));
  };
  handleRowsPerPage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: 1,
              limit: tableState.rowsPerPage,
          }
      }));
  };

  render() {
    const {pagination} = this.state;
    return (
      <>
        <SimpleModal
          title="Detail COA"
          visible={this.props.visible}
          onClickClose={() => this.props.onClickClose()}
          content={
            <ModalContainer>
              <MasterCOAHeader
                {...this.props}
                errorListCabang={this.state.errorListCabang}
                errorStartDate={this.state.errorStartDate}
                errorEndDate={this.state.errorEndDate}
              />

              <FlexView vAlignContent="center" className="margin-bottom-10px">
                <SimpleButton
                  className="btn btn-plus background-red margin-left-none"
                  onClick={this.handleAddRow}
                  icon={<i className="fa fa-plus margin-right-10px"></i>}
                  text="Tambah"
                />
              </FlexView>

              <SimpleDataTable
                key={`${pagination.totalData}-${pagination.page}`}
                data={this.state.dataTable}
                columns={this.state.tableColumn}
                toCount={pagination.totalData}
                rowsPerPage={pagination.limit}
                page={pagination.page - 1}
                options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
              />

              <div style={{ textAlign: "right", marginTop: "10px" }}>
                <SimpleButton
                  text="Simpan"
                  type="button"
                  onClick={() => this.handleSubmit()}
                />
              </div>
            </ModalContainer>
          }
        />

        {this.state.warningModalVisible && (
          <SimpleAlert
            title="Information"
            content={
              <div>
                <p>
                  {this.state.warningModalMessage}
                  <br />
                  Mohon periksa kembali.
                </p>
              </div>
            }
            additionalButtons={
              <Fragment>
                <FlexView>
                  <SimpleButton
                    text="OK"
                    secondary
                    onClick={() => this.handleWarningModalVisibility()}
                  />
                </FlexView>
              </Fragment>
            }
            visible={this.state.warningModalVisible}
            onClickClose={this.handleWarningModalVisibility}
          />
        )}

        <SimpleLoadingOverlay active={this.state.loading} />
      </>
    );
  }
}

export default withFormGroup(MasterCOAModifying);
